import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from './baseQueryWithReauth';

// Define a service using a base URL and expected endpoints
export const projectApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 0,
  tagTypes: ['project'],
  endpoints: (builder) => ({    
    projects: builder.query<any, string>({
      query: (clientId: string) => `client/${clientId}/project`,
    }),
    getProject: builder.query<any, { clientId: string, projectId: string }>({      
      query: (arg) => {
        const { clientId, projectId } = arg;
        return `client/${clientId}/project/${projectId}`
      },
      providesTags: (returnValue, args) => [{ type: 'project' as const, id: 'LIST' }, ...(returnValue?.data || []).map((project: any) => ({ type: 'project' as const, id: project.id }))]
    }),
    add: builder.mutation<any, any>({
      query: (formData: any) => {
        const { clientId } = formData;
        return {
        url: `client/${clientId}/project`,
        method: 'POST',
        body: formData,
      }},
      invalidatesTags: ['project'],
    }),
    update: builder.mutation<any, any>({
      query: (formData: any) => {
        const { clientId, projectId } = formData;
        return {
        url: `client/${clientId}/project/${projectId}`,
        method: 'PUT',
        body: formData,
      }},
      invalidatesTags: ['project'],
    }),
    delete: builder.mutation<any, any>({
      query: (formData: any) => {
        const { clientId, projectId } = formData;
        return {
        url: `client/${clientId}/project/${projectId}`,
        method: 'DELETE'
      }},
      invalidatesTags: ['project'],
    }),
  }),  
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useProjectsQuery, useAddMutation, useUpdateMutation, useGetProjectQuery, useDeleteMutation } = projectApi;